import { User } from '../api/app-types/user.app';
import { Representation } from '../api/app-types/representation.app';
import { employmentMocks } from './employment.mock';
import { integrationOfficeMocks } from './integration-office.mock';
import { integrationServiceMocks } from './integration-service.mock';
import { roleMocks } from './role.mock';

export const mockUser: User = {
	id: '1',
	objectId: '4394a3ac-cb72-494d-8b6d-82730affa553',
	displayName: 'Doe, John',
	firstName: 'John',
	lastName: 'Doe',
	email: 'john.doe@example.com',
	positionShare: { id: 1, share: 100, start: new Date().toISOString() },
	service: integrationServiceMocks[0],
	employment: employmentMocks[0],
	integrationServiceOffice: integrationOfficeMocks[0],
	roles: roleMocks[0],
	isActive: true,
};

export const representationMocks: Representation[] = [];

export const possibleRepresentationMocks: Representation[] = [
	{
		id: '3',
		displayName: 'Mara Test',
		firstName: 'Mara',
		lastName: 'Test',
		role: 'Fachkraft',
		service: 'System Service',
		specialisation: 'Spezialisierung 1',
	},
	{
		id: '4',
		displayName: 'Alex Beispiel',
		firstName: 'Alex',
		lastName: 'Beispiel',
		role: 'Fachkraft',
		service: 'System Service',
		specialisation: 'Spezialisierung 2',
	},
	{
		id: '1',
		displayName: 'Anna Beispiel',
		firstName: 'Anna',
		lastName: 'Beispiel',
		role: 'Fachkraft',
		service: 'System Service',
		specialisation: 'Spezialisierung 3',
	},
	{
		id: '2',
		displayName: 'Jens Muster',
		firstName: 'Jens',
		lastName: 'Muster',
		role: 'Fachkraft',
		service: 'System Service',
		specialisation: 'Spezialisierung 4',
	},
];
